import React, { forwardRef } from 'react';

import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const UserSmallIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  function UserSmallIcon(props, ref) {
    return (
      <SvgIcon
        ref={ref}
        viewBox="0 0 14 14"
        {...props}
        style={{ height: 14, width: 14, ...props.style }}
      >
        <circle cx="7" cy="4" fill="none" r="2.5" stroke="currentColor" strokeWidth="1.2" />
        <path
          d="M2.5 12.5C2.5 10.0147 4.51472 8 7 8C9.48528 8 11.5 10.0147 11.5 12.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
      </SvgIcon>
    );
  }
);
